<template>
  <day-select-dropdown :selectedDate="displaydate" @date-selected="dateSelected" mode="day">
    <template #trigger="{ toggleDropdown }">
      <div class="date-select">
        <icon icon="chevron-left"
              @click="changeDate(-1)" />

        <p class="date" @click="toggleDropdown">
          {{ dateFormatted }}
        </p>

        <icon icon="chevron-right"
              @click="changeDate(1)" />
      </div>
    </template>
  </day-select-dropdown>
</template>

<script>
import moment from "moment";
import DaySelectDropdown from '@/components/common/DaySelectDropdown.vue';


export default {
  name: "date-select",
  components: { DaySelectDropdown },
  props: {
    value: {
      type: Date,
      required: true,
    },
    debounceTime: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    date(val) {
      this.date = val;
    },
  },
  mounted() {
    this.displaydate = this.date;
  },
  computed: {
    dateFormatted() {
      return new Intl.DateTimeFormat("da-DK", {
        day: "numeric",
        month: "short",
      }).format(this.displaydate);
    },
  },
  data: () => ({
    debouncing: false,
    debounce: null,
    displaydate: null,
  }),
  methods: {
    changeDate(howMuch) {
      const newDate = moment(this.displaydate).add(howMuch, "days").toDate();

      if (this.debounceTime === 0) {
        this.$emit("input", newDate);
      } else {
        if (this.debouncing) {
          clearTimeout(this.debounce);
        }

        this.displaydate = newDate;
        this.debouncing = true;

        this.debounce = setTimeout(() => {
          this.$emit("input", newDate);
          this.debouncing = false;
        }, this.debounceTime);
      }
    },
    dateSelected(date) {
      const currentMoment = moment(this.displaydate),
            selectedMoment = moment(date);
      let daysDiff = selectedMoment.diff(currentMoment, 'days');
      if (daysDiff > -1) {
        daysDiff++;
      }
      this.changeDate(daysDiff);
    }
  },
};
</script>

<style lang="scss" scoped>
.date-select {
  display: flex;

  .date {
    margin: 0px 5px;
    flex: 1;
    color: white;
    background: $secondary;

    @include center-full;
  }
}
</style>

<style lang="scss">
  .dayselectdropdown {
    .dayselectdropdown__dropdown {
      top: 35px !important;
      right: -4px !important;

      .dayselectdropdown__dayspanel {
        box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
      }
    }
  }
</style>
